import React, { useState } from "react";
import { useFormikContext } from "formik";
import visa from "../../../../../../../images/v2/visa24x24.svg";
import mastercard from "../../../../../../../images/v2/master24x24.svg";
import discover from "../../../../../../../images/v2/discover24x24.svg";
import amex from "../../../../../../../images/v2/amex24x24.svg";
import TextInput from "../../../../../components/form/text-input";
import FancyRadioInput from "../../../../../components/form/fancy-radio-input";
import styles from "./style.module.scss";

const Tiered = () => {
  const [amexStructure, setAmexStructure] = useState("flat_rate");
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext();

  const onChangeAmexStructure = (event) => {
    console.log("event", event.target.value);
    setAmexStructure(event.target.value);
  };

  const hasWarning = (value) => {
    if (value > 1) {
      return "Please check pricing.";
    }
    return "";
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h6>Qualified</h6>
          <div className={styles.accepts}>
            <img src={visa} />
            <img src={mastercard} />
            <img src={discover} />
          </div>
        </div>

        <div className={`${styles.body} ${styles.gridCol4}`}>
          <TextInput
            label={"Qual Rate"}
            placeholder={"0.00"}
            suffix={"%"}
            type="text"
            id={"tiered_qual_rate"}
            name={"tiered_qual_rate"}
            value={values.tiered_qual_rate}
            onBlur={handleBlur}
            touched={touched?.tiered_qual_rate}
            errored={errors?.tiered_qual_rate}
            error={errors?.tiered_qual_rate}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_qual_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Txn rate"}
            placeholder={"0.00"}
            prefix={"$"}
            id={"tiered_qual_transaction"}
            name={"tiered_qual_transaction"}
            value={values.tiered_qual_transaction}
            onBlur={handleBlur}
            touched={touched?.tiered_qual_transaction}
            errored={errors?.tiered_qual_transaction}
            error={errors?.tiered_qual_transaction}
            hasWarning={hasWarning(values?.tiered_qual_transaction)}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_qual_transaction",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Debit Rate"}
            placeholder={"0.00"}
            suffix={"%"}
            type="text"
            id={"tiered_qual_debit_rate"}
            name={"tiered_qual_debit_rate"}
            value={values.tiered_qual_debit_rate}
            onBlur={handleBlur}
            touched={touched?.tiered_qual_debit_rate}
            errored={errors?.tiered_qual_debit_rate}
            error={errors?.tiered_qual_debit_rate}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_qual_debit_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Debit Per Txn"}
            placeholder={"0.00"}
            prefix={"$"}
            id={"tiered_qual_debit_per_transaction"}
            name={"tiered_qual_debit_per_transaction"}
            value={values.tiered_qual_debit_per_transaction}
            onBlur={handleBlur}
            touched={touched?.tiered_qual_debit_per_transaction}
            errored={errors?.tiered_qual_debit_per_transaction}
            error={errors?.tiered_qual_debit_per_transaction}
            hasWarning={hasWarning(values?.tiered_qual_debit_per_transaction)}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_qual_debit_per_transaction",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
        </div>
      </div>

      <div className={styles.card}>
        <div className={styles.header}>
          <h6>Mid-Qualified</h6>
          <div className={styles.accepts}>
            <img src={visa} />
            <img src={mastercard} />
            <img src={discover} />
          </div>
        </div>

        <div className={`${styles.body} ${styles.gridCol4}`}>
          <TextInput
            label={"Qual Rate"}
            placeholder={"0.00"}
            suffix={"%"}
            type="text"
            id={"tiered_mid_qual_rate"}
            name={"tiered_mid_qual_rate"}
            value={values.tiered_mid_qual_rate}
            onBlur={handleBlur}
            touched={touched?.tiered_mid_qual_rate}
            errored={errors?.tiered_mid_qual_rate}
            error={errors?.tiered_mid_qual_rate}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_mid_qual_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Txn rate"}
            placeholder={"0.00"}
            prefix={"$"}
            id={"tiered_mid_qual_transaction"}
            name={"tiered_mid_qual_transaction"}
            value={values.tiered_mid_qual_transaction}
            onBlur={handleBlur}
            touched={touched?.tiered_mid_qual_transaction}
            errored={errors?.tiered_mid_qual_transaction}
            error={errors?.tiered_mid_qual_transaction}
            hasWarning={hasWarning(values?.tiered_mid_qual_transaction)}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_mid_qual_transaction",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Debit Rate"}
            placeholder={"0.00"}
            suffix={"%"}
            type="text"
            id={"tiered_mid_qual_debit_rate"}
            name={"tiered_mid_qual_debit_rate"}
            value={values.tiered_mid_qual_debit_rate}
            onBlur={handleBlur}
            touched={touched?.tiered_mid_qual_debit_rate}
            errored={errors?.tiered_mid_qual_debit_rate}
            error={errors?.tiered_mid_qual_debit_rate}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_mid_qual_debit_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Debit Per Txn"}
            placeholder={"0.00"}
            prefix={"$"}
            id={"tiered_mid_qual_debit_per_transaction"}
            name={"tiered_mid_qual_debit_per_transaction"}
            value={values.tiered_mid_qual_debit_per_transaction}
            onBlur={handleBlur}
            touched={touched?.tiered_mid_qual_debit_per_transaction}
            errored={errors?.tiered_mid_qual_debit_per_transaction}
            error={errors?.tiered_mid_qual_debit_per_transaction}
            hasWarning={hasWarning(values?.tiered_mid_qual_debit_per_transaction)}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_mid_qual_debit_per_transaction",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
        </div>
      </div>

      <div className={styles.card}>
        <div className={styles.header}>
          <h6>non-Qualified</h6>
          <div className={styles.accepts}>
            <img src={visa} />
            <img src={mastercard} />
            <img src={discover} />
          </div>
        </div>

        <div className={`${styles.body} ${styles.gridCol4}`}>
          <TextInput
            label={"Qual Rate"}
            placeholder={"0.00"}
            suffix={"%"}
            type="text"
            id={"tiered_non_qual_rate"}
            name={"tiered_non_qual_rate"}
            value={values.tiered_non_qual_rate}
            onBlur={handleBlur}
            touched={touched?.tiered_non_qual_rate}
            errored={errors?.tiered_non_qual_rate}
            error={errors?.tiered_non_qual_rate}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_non_qual_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Txn rate"}
            placeholder={"0.00"}
            prefix={"$"}
            type="text"
            id={"tiered_non_qual_transaction"}
            name={"tiered_non_qual_transaction"}
            value={values.tiered_non_qual_transaction}
            onBlur={handleBlur}
            touched={touched?.tiered_non_qual_transaction}
            errored={errors?.tiered_non_qual_transaction}
            error={errors?.tiered_non_qual_transaction}
            hasWarning={hasWarning(values?.tiered_non_qual_transaction)}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_non_qual_transaction",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Debit Rate"}
            placeholder={"0.00"}
            suffix={"%"}
            type="text"
            id={"tiered_non_qual_debit_rate"}
            name={"tiered_non_qual_debit_rate"}
            value={values.tiered_non_qual_debit_rate}
            onBlur={handleBlur}
            touched={touched?.tiered_non_qual_debit_rate}
            errored={errors?.tiered_non_qual_debit_rate}
            error={errors?.tiered_non_qual_debit_rate}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_non_qual_debit_rate",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
          <TextInput
            label={"Debit Per Txn"}
            placeholder={"0.00"}
            prefix={"$"}
            type="text"
            id={"tiered_non_qual_debit_per_transaction"}
            name={"tiered_non_qual_debit_per_transaction"}
            value={values.tiered_non_qual_debit_per_transaction}
            onBlur={handleBlur}
            touched={touched?.tiered_non_qual_debit_per_transaction}
            errored={errors?.tiered_non_qual_debit_per_transaction}
            error={errors?.tiered_non_qual_debit_per_transaction}
            hasWarning={hasWarning(values?.tiered_non_qual_debit_per_transaction)}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralIntegerScale: 4,
              numeralPositiveOnly: true,
              onValueChanged: (e) => {
                handleChange({
                  target: {
                    name: "tiered_non_qual_debit_per_transaction",
                    value: e.target.rawValue,
                  },
                });
              },
            }}
          />
        </div>
      </div>

      <div className={styles.amexCard}>
        <div className={styles.amexHeader}>
          <h6>Amex structure</h6>
          <img src={amex} />
        </div>

        <p>Select preferred AMEX Structure</p>

        <div className={styles.radioBoxes}>
          <FancyRadioInput
            label={"Flat Rate"}
            id={"amex_flat_rate"}
            name={"tiered_amex_structure"}
            value={"flat_rate"}
            defaultChecked={values?.tiered_amex_structure === "flat_rate"}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "tiered_amex_structure",
                  value: e.target.value,
                },
              })
            }
          />
          <FancyRadioInput
            label={"IC+"}
            id={"amex_ic_plus"}
            name={"tiered_amex_structure"}
            value={"ic_plus"}
            defaultChecked={values?.tiered_amex_structure === "ic_plus"}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "tiered_amex_structure",
                  value: e.target.value,
                },
              })
            }
          />
          <FancyRadioInput
            label={"Tiered"}
            id={"amex_tiered"}
            name={"tiered_amex_structure"}
            value={"tiered"}
            defaultChecked={values?.tiered_amex_structure === "tiered"}
            onChange={(e) =>
              handleChange({
                target: {
                  name: "tiered_amex_structure",
                  value: e.target.value,
                },
              })
            }
          />
        </div>

        {values?.tiered_amex_structure === "flat_rate" && (
          <div className={styles.card}>
            <div className={styles.header}>
              <h6>Amex flat rate</h6>
            </div>

            <div className={`${styles.body} ${styles.gridCol2}`}>
              <TextInput
                label={"Flat Rate"}
                placeholder={"0.00"}
                suffix={"%"}
                type="text"
                id={"tiered_amex_flat_rate"}
                name={"tiered_amex_flat_rate"}
                value={values.tiered_amex_flat_rate}
                onBlur={handleBlur}
                touched={touched?.tiered_amex_flat_rate}
                errored={errors?.tiered_amex_flat_rate}
                error={errors?.tiered_amex_flat_rate}
                cleaveOptions={{
                  numeral: true,
                  numeralDecimalScale: 2,
                  numeralIntegerScale: 4,
                  numeralPositiveOnly: true,
                  onValueChanged: (e) => {
                    handleChange({
                      target: {
                        name: "tiered_amex_flat_rate",
                        value: e.target.rawValue,
                      },
                    });
                  },
                }}
              />
              <TextInput
                label={"Txn Fee"}
                placeholder={"0.00"}
                prefix={"$"}
                type="text"
                id={"tiered_amex_flat_transaction"}
                name={"tiered_amex_flat_transaction"}
                value={values.tiered_amex_flat_transaction}
                onBlur={handleBlur}
                touched={touched?.tiered_amex_flat_transaction}
                errored={errors?.tiered_amex_flat_transaction}
                error={errors?.tiered_amex_flat_transaction}
                hasWarning={hasWarning(values?.tiered_amex_flat_transaction)}
                cleaveOptions={{
                  numeral: true,
                  numeralDecimalScale: 2,
                  numeralIntegerScale: 4,
                  numeralPositiveOnly: true,
                  onValueChanged: (e) => {
                    handleChange({
                      target: {
                        name: "tiered_amex_flat_transaction",
                        value: e.target.rawValue,
                      },
                    });
                  },
                }}
              />
            </div>
          </div>
        )}

        {values?.tiered_amex_structure === "ic_plus" && (
          <div className={styles.card}>
            <div className={styles.header}>
              <h6>Amex Interchange rate</h6>
            </div>

            <div className={`${styles.body} ${styles.gridCol2}`}>
              <TextInput
                label={"IC+ Rate"}
                placeholder={"0.00"}
                suffix={"%"}
                type="text"
                id={"tiered_amex_ic_plus_rate"}
                name={"tiered_amex_ic_plus_rate"}
                value={values.tiered_amex_ic_plus_rate}
                onBlur={handleBlur}
                touched={touched?.tiered_amex_ic_plus_rate}
                errored={errors?.tiered_amex_ic_plus_rate}
                error={errors?.tiered_amex_ic_plus_rate}
                cleaveOptions={{
                  numeral: true,
                  numeralDecimalScale: 2,
                  numeralIntegerScale: 4,
                  numeralPositiveOnly: true,
                  onValueChanged: (e) => {
                    handleChange({
                      target: {
                        name: "tiered_amex_ic_plus_rate",
                        value: e.target.rawValue,
                      },
                    });
                  },
                }}
              />
              <TextInput
                label={"Txn Fee"}
                placeholder={"0.00"}
                prefix={"$"}
                type="text"
                id={"tiered_amex_ic_plus_transaction"}
                name={"tiered_amex_ic_plus_transaction"}
                value={values.tiered_amex_ic_plus_transaction}
                onBlur={handleBlur}
                touched={touched?.tiered_amex_ic_plus_transaction}
                errored={errors?.tiered_amex_ic_plus_transaction}
                error={errors?.tiered_amex_ic_plus_transaction}
                hasWarning={hasWarning(values?.tiered_amex_ic_plus_transaction)}
                cleaveOptions={{
                  numeral: true,
                  numeralDecimalScale: 2,
                  numeralIntegerScale: 4,
                  numeralPositiveOnly: true,
                  onValueChanged: (e) => {
                    handleChange({
                      target: {
                        name: "tiered_amex_ic_plus_transaction",
                        value: e.target.rawValue,
                      },
                    });
                  },
                }}
              />
            </div>
          </div>
        )}

        {values?.tiered_amex_structure === "tiered" && (
          <div
            className={`${styles.body} ${styles.gridCol2} ${styles.gridRow2} ${styles.gap8}`}
          >
            <div className={styles.card}>
              <div className={styles.header}>
                <h6>Amex Tier 1</h6>
              </div>

              <div className={`${styles.body} ${styles.gridCol2}`}>
                <TextInput
                  label={"Rate"}
                  placeholder={"0.00"}
                  suffix={"%"}
                  type="text"
                  id={"amex_tier_one_rate"}
                  name={"amex_tier_one_rate"}
                  value={values.amex_tier_one_rate}
                  onBlur={handleBlur}
                  touched={touched?.amex_tier_one_rate}
                  errored={errors?.amex_tier_one_rate}
                  error={errors?.amex_tier_one_rate}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "amex_tier_one_rate",
                          value: e.target.rawValue,
                        },
                      });
                    },
                  }}
                />
                <TextInput
                  label={"Txn Fee"}
                  placeholder={"0.00"}
                  prefix={"$"}
                  type="text"
                  id={"amex_tier_one_fee"}
                  name={"amex_tier_one_fee"}
                  value={values.amex_tier_one_fee}
                  onBlur={handleBlur}
                  touched={touched?.amex_tier_one_fee}
                  errored={errors?.amex_tier_one_fee}
                  error={errors?.amex_tier_one_fee}
                  hasWarning={hasWarning(values?.amex_tier_one_fee)}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "amex_tier_one_fee",
                          value: e.target.rawValue,
                        },
                      });
                    },
                  }}
                />
              </div>
            </div>

            <div className={styles.card}>
              <div className={styles.header}>
                <h6>Amex Tier 2</h6>
              </div>

              <div className={`${styles.body} ${styles.gridCol2}`}>
                <TextInput
                  label={"Rate"}
                  placeholder={"0.00"}
                  suffix={"%"}
                  type="text"
                  id={"amex_tier_two_rate"}
                  name={"amex_tier_two_rate"}
                  value={values.amex_tier_two_rate}
                  onBlur={handleBlur}
                  touched={touched?.amex_tier_two_rate}
                  errored={errors?.amex_tier_two_rate}
                  error={errors?.amex_tier_two_rate}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "amex_tier_two_rate",
                          value: e.target.rawValue,
                        },
                      });
                    },
                  }}
                />
                <TextInput
                  label={"Txn Fee"}
                  placeholder={"0.00"}
                  prefix={"$"}
                  type="text"
                  id={"amex_tier_two_fee"}
                  name={"amex_tier_two_fee"}
                  value={values.amex_tier_two_fee}
                  onBlur={handleBlur}
                  touched={touched?.amex_tier_two_fee}
                  errored={errors?.amex_tier_two_fee}
                  error={errors?.amex_tier_two_fee}
                  hasWarning={hasWarning(values?.amex_tier_two_fee)}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "amex_tier_two_fee",
                          value: e.target.rawValue,
                        },
                      });
                    },
                  }}
                />
              </div>
            </div>

            <div className={styles.card}>
              <div className={styles.header}>
                <h6>Amex Tier 3</h6>
              </div>

              <div className={`${styles.body} ${styles.gridCol2}`}>
                <TextInput
                  label={"Rate"}
                  placeholder={"0.00"}
                  suffix={"%"}
                  type="text"
                  id={"amex_tier_three_rate"}
                  name={"amex_tier_three_rate"}
                  value={values.amex_tier_three_rate}
                  onBlur={handleBlur}
                  touched={touched?.amex_tier_three_rate}
                  errored={errors?.amex_tier_three_rate}
                  error={errors?.amex_tier_three_rate}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "amex_tier_three_rate",
                          value: e.target.rawValue,
                        },
                      });
                    },
                  }}
                />
                <TextInput
                  label={"Txn Fee"}
                  placeholder={"0.00"}
                  prefix={"$"}
                  type="text"
                  id={"amex_tier_three_fee"}
                  name={"amex_tier_three_fee"}
                  value={values.amex_tier_three_fee}
                  onBlur={handleBlur}
                  touched={touched?.amex_tier_three_fee}
                  errored={errors?.amex_tier_three_fee}
                  error={errors?.amex_tier_three_fee}
                  hasWarning={hasWarning(values?.amex_tier_three_fee)}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "amex_tier_three_fee",
                          value: e.target.rawValue,
                        },
                      });
                    },
                  }}
                />
              </div>
            </div>

            <div className={styles.card}>
              <div className={styles.header}>
                <h6>Amex Tier 4</h6>
              </div>

              <div className={`${styles.body} ${styles.gridCol2}`}>
                <TextInput
                  label={"Rate"}
                  placeholder={"0.00"}
                  suffix={"%"}
                  type="text"
                  id={"amex_tier_four_rate"}
                  name={"amex_tier_four_rate"}
                  value={values.amex_tier_four_rate}
                  onBlur={handleBlur}
                  touched={touched?.amex_tier_four_rate}
                  errored={errors?.amex_tier_four_rate}
                  error={errors?.amex_tier_four_rate}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "amex_tier_four_rate",
                          value: e.target.rawValue,
                        },
                      });
                    },
                  }}
                />
                <TextInput
                  label={"Txn Fee"}
                  placeholder={"0.00"}
                  prefix={"$"}
                  type="text"
                  id={"amex_tier_four_fee"}
                  name={"amex_tier_four_fee"}
                  value={values.amex_tier_four_fee}
                  onBlur={handleBlur}
                  touched={touched?.amex_tier_four_fee}
                  errored={errors?.amex_tier_four_fee}
                  error={errors?.amex_tier_four_fee}
                  hasWarning={hasWarning(values?.amex_tier_four_fee)}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "amex_tier_four_fee",
                          value: e.target.rawValue,
                        },
                      });
                    },
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tiered;
